var travel = travel || {};

travel.search = (function() {
	function init() {
		var searchForm = document.querySelector('#travelOffer');
		if (!searchForm) {
			return;
		}

		initAutoComplete(searchForm);
		initFormPost(searchForm);
		initCategoryChangeEvent();
	}

	function initFormPost(searchForm) {
		searchForm.addEventListener('submit', function(e) {
			if (e.target.q) {
				var v = e.target.q.value.replace(/\*$/, '');
				e.target.q.value = v + '*';
			}
			return true;
		});
	}

	function initAutoComplete(searchForm) {
		var quickUrl = searchForm.dataset.providers;
		if (!quickUrl) {
			return;
		}
		var q = searchForm.querySelector('#providerName');
		if (!q) {
			return;
		}

		var externalId = searchForm.querySelector('#externalId');

		if (q.value && externalId.value) {
			if (!q.getAttribute('aria-describedby')) {
				q.classList.add('ready');
			}
		}


		var $q = $(q).autocomplete({
			source: function(request, response) {
				$.ajax({
					url: quickUrl,
					dataType: 'json',
					data: {
						q: encodeURIComponent(request.term)
					},
					success: function (data) {
						document.querySelector('#externalId').value = '';
						q.classList.remove('ready');
						response(data);

					}
				});
			},
			minLength: 3,
			autoFocus: true,
			select: autocompleteSelect,
			focus: autocompleteFocus,
		});
		var qInst = $q.autocomplete( "instance" );
		qInst._renderItem = renderItem;
		qInst._renderMenu = renderMenu;
	}

	function renderMenu($ul, items) {
		$ul.addClass('travelOffer');
		var that = this;
		$.each( items, function( index, item ) {
			that._renderItemData( $ul, item );
		});
	}

	function renderItem(ul, item) {
		var $name = $('<span>').addClass('n').text(item.name);
		if(item.address) {
			var $address = $('<span>').addClass('a').text(item.address);
			var $zip = $('<span>').addClass('z').text(item.zip);
			return $('<li>')
				.append($name)
				.append($address)
				.append($zip)
				.appendTo(ul);
		} else {
			return $('<li>')
				.append($name)
				.appendTo(ul);
		}
	}

	function autocompleteSelect(event, ui) {
		if (ui.item && ui.item.externalId && ui.item.name) {
			event.target.value = ui.item.name;
			event.target.classList.add('ready');
			let $error = document.querySelector('#error_providerName');
			if ($error) {
				$error.remove();
			}
			document.querySelector('#externalId').value = ui.item.externalId;
			appendCategoryOptions(ui.item.categories);
		}
		return false;
	}

	function autocompleteFocus (event, ui) {
		// Do nothing
		return false;
	}

	function initCategoryChangeEvent() {
		let categorySelect = document.querySelector('select#categorySelect');
		let category = document.getElementById('category');
		if (categorySelect) {
			categorySelect.addEventListener('change', (event) => {
				category.value = event.target.value;
			});
		}
	}

	function appendCategoryOptions(options) {
		$('#categorySelect').empty();
		let categorySelect = document.getElementById('categorySelect');
		Object.keys(options).forEach(function(key) {
			categorySelect.options[categorySelect.options.length] = new Option(options[key], key);
		});

		let category = document.getElementById('category');
		category.value = Object.keys(options)[0];
	}

	init();

	return {

	}
})();
